import { $api, getUrlWithVersion } from '../../../api/api'
import { Survey } from '../../../types/survey'

export const getSurvey = async () => {
    try {
        const res = await $api.get<Survey>(getUrlWithVersion(`/surveys/random`))

        return res.status === 204 ? null : res.data
    } catch (error) {
        console.error('Error fetching survey:', error)
        throw new Error('Failed to fetch survey')
    }
}
